function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-146.667 -146.667)"
}, React.createElement("circle", {
  cx: 426.667,
  cy: 426.667,
  fill: "#4D2C91",
  r: 280
}), React.createElement("path", {
  d: "M257.317 234.687a256 256 0 01338.7 0l.28 3.68.43 7.35.14 7.21-.07 7.15-.28 7.2-.22 3.47h-7.07l-6.78.29-6.86.5-6.8.7-6.64.85a204.8 204.8 0 00-289.06 289.06l-3.33.07-6.71-.07-6.86-.21-6.93-.57s-3.4-.28-6.86-.77l-3.54-.43-1.27 6.93-1.06 7.14-.78 7.14-.7 7.22-.43 7.35a256 256 0 0122.7-361.26zm361.33 361.33a256 256 0 000-338.7l-.14 3.67-.57 7.36-.7 7.21-1 7.07-1.13 7.07-.7 3.54-6.93-1-6.93-.56s-3.4-.28-6.72-.35l-6.86-.21-6.72.07a204.8 204.8 0 01-289.06 289.06l-3.33.5-6.71.78-6.8.56-6.85.36-6.93.14h-3.53l-.43 7.07s-.14 3.53-.07 7.14l-.07 7.14.28 7.36.57 7.35a256 256 0 00361.33-22.63z",
  fill: "#b085f5"
}, React.createElement("animateTransform", {
  begin: "indefinite",
  attributeType: "xml",
  attributeName: "transform",
  type: "rotate",
  from: "0 426.667 426.667",
  to: "360 426.667 426.667",
  dur: "2s",
  additive: "sum",
  repeatCount: "indefinite"
})), React.createElement("path", {
  d: "M456.667 259.467v60h100l-40 60h-60v102.5l.2 2.4.2 2.4.4 2.4.4 2.4.5 2.3.7 2.3.7 2.3.8 2.2.8 2.1 1 2.2 1 2 1.1 2.1 1.2 2 1.3 2 1.3 1.8 1.4 1.9 1.4 1.8 1.6 1.7 1.6 1.6 1.6 1.6 1.8 1.6 1.7 1.4 1.9 1.4 1.8 1.4 2 1.2 2 1.2 2 1.1 2.1 1 2.1 1 2.2.8 2.2.8 2.3.7 2.3.7 2.3.5 2.4.4 2.4.4 2.4.2 2.4.1 2.5.1-36.3 54.4-1.6-.5-4.5-1.6-4.3-1.7-4.3-2-4.1-2-4.1-2.2-4-2.4-3.9-2.5-3.8-2.7-3.6-2.8-3.6-2.9-3.4-3-3.4-3.3-3.2-3.3-3-3.4-3-3.6-2.8-3.6-2.6-3.8-2.5-3.9-2.4-4-2.2-4-2-4.2-2-4.3-1.7-4.3-1.6-4.5-1.4-4.5-1.2-4.6-1-4.6-1-4.7-.6-4.8-.5-4.9-.3-4.9-.1-4.9v-100h-100l40-60h60v-60h60z",
  fill: "#fff"
}));

function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 560 560",
    ref: svgRef
  }, props), _ref2);
}

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;